import AbstractMediator from "../../../core/ui/AbstractMediator";
import FileModel from "../model/FileModel";
import FileTreeNode from "../model/FileTreeNode";
import FileInteractionEvent from "../model/FileInteractionEvent";
import FileExplorerModel from "../model/FileExplorerModel";

export default class FileExplorerItemMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {FileExplorerModel} fileExplorerModel 
     * @param {FileModel} fileModel 
     */
    constructor(target, dispatcher, fileExplorerModel, fileModel) {
        super(target, dispatcher);

        this._fileExplorerModel = fileExplorerModel;
        this._fileModel = fileModel;

        /** @type {FileTreeNode} */
        this._fileTreeNode = this.getCustomData().fileTreeNode;
        this._data = this._fileTreeNode.data;
    }

    initialize() {
        super.initialize();

        this._itemButton = this.createButton(this._target, this._onClick.bind(this), this._data.getName());

        if (this._isDirectory()) {
            this._setIcon(FileExplorerItemMediator.DIRECTORY_ICON);
        } else {
            this._setIcon(this._data.getIcon());
        }

        this._updateNewNotification();
    }

    _onClick() {
        if (this._isDirectory()) {
            const nextNode = this._fileExplorerModel.currentFileTreeNode.children.find(c => c.data === this._data);
            this._fileExplorerModel.currentFileTreeNode = nextNode;
        } else {
            this._fileModel.markFileAsOpened(this._data);
            this._updateNewNotification();

            const evt = new FileInteractionEvent(FileInteractionEvent.OPEN_FILE, this._data);
            this.dispatch(evt.type, { data: evt });
        }
    }

    _setIcon(iconType) {
        for (let i = 0; i < FileExplorerItemMediator.ICONS.length; i++) {
            const icon = FileExplorerItemMediator.ICONS[i];
            let iconSkin = this._target[`${icon}Icon`];
            if (!iconSkin) {
                console.warn(`Cannot set icon to type of '${iconType}' as it doesn't exist in the assets.`);
                continue;
            }

            iconSkin.visible = icon === iconType;
        }
    }

    _updateNewNotification() {
        if (this._isDirectory()) {
            this._target.newNotification.visible = this._fileModel.branchContainsNewFiles(this._fileTreeNode);
        } else {
            this._target.newNotification.visible = this._fileModel.fileIsNew(this._data);
        }
    }

    _isDirectory() {
        return this._fileTreeNode.children.length > 0;
    }

    get skin() {
        return this._target;
    }

    get file() {
        return this._file;
    }
}


FileExplorerItemMediator.DIRECTORY_ICON = "directory";
FileExplorerItemMediator.SPREADSHEET_ICON = "spreadsheet";
FileExplorerItemMediator.PDF_ICON = "pdf";
FileExplorerItemMediator.SLIDES_ICON = "slides";
FileExplorerItemMediator.DOCUMENT_ICON = "document";
FileExplorerItemMediator.IMAGE_ICON = "image";

FileExplorerItemMediator.ICONS = [
    FileExplorerItemMediator.DIRECTORY_ICON,
    FileExplorerItemMediator.SPREADSHEET_ICON,
    FileExplorerItemMediator.PDF_ICON,
    FileExplorerItemMediator.SLIDES_ICON,
    FileExplorerItemMediator.DOCUMENT_ICON,
    FileExplorerItemMediator.IMAGE_ICON,
];